import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = {};

const updateOne = (state, { payload }) => ({
  ...state,
  [payload.bodyScan.id]: {
    ...(state?.[payload.bodyScan.id] ?? {}),
    ...payload.bodyScan,
  },
});

const updateAll = (state, { payload }) =>
  payload.content?.reduce((newState, bodyScan) => updateOne(newState, { payload: { bodyScan } }), state) ?? state;

export default createReducer(initialState, {
  [actionTypes.SEARCH_BODY_SCANS_SUCCESS]: updateAll,
});
